import { useState, useMemo, type ReactNode } from 'react';
import { getBboxCenter } from '@/helpers/geo';
import { HoverContext, type HoveredItem } from '@/features/hoverContext';
import type { LngLatBase } from '@/views/map/types';

const getHoverLocation = (item: HoveredItem | null): LngLatBase | null => {
  if (!item) return null;
  return item.source === 'map' ? item.coordinate : getBboxCenter(item.bbox);
};

export const HoverProvider = ({ children }: { children: ReactNode }) => {
  const [hoveredItem, setHoveredItem] = useState<HoveredItem | null>(null);

  const value = useMemo(
    () => ({
      hoveredItem,
      setHoveredItem,
      hoverLocation: getHoverLocation(hoveredItem),
    }),
    [hoveredItem]
  );

  return (
    <HoverContext.Provider value={value}>{children}</HoverContext.Provider>
  );
};
